import List from 'src/storage/list';

class AdminTicketsModel extends List {
  id = 'AdminTicketsModel';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    sortBy: {
      sortKey: 'date',
      desc: true
    }
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'admin/ticket/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'admin/ticket/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'admin/ticket/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }
  logAsDoctor = (item) => {
    this.emit('login_as_other_user', { id: item.id });
  };
}

const model = new AdminTicketsModel();
export default model;
